import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Play } from 'lucide-react';
import { Button } from './ui/button';

const videos = [
  {
    id: '8ohMb3qhhAQ',
    title: 'Viubux - Video 1',
    url: 'https://www.youtube.com/embed/8ohMb3qhhAQ?autoplay=0&rel=0'
  },
  {
    id: 'NZoXW_wFpNw',
    title: 'Viubux - Video 2',
    url: 'https://www.youtube.com/embed/NZoXW_wFpNw?autoplay=0&rel=0'
  }
];

export function VideoCarouselModal({ isOpen, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!isOpen) return null;

  const goNext = () => setCurrentIndex((prev) => (prev + 1) % videos.length);
  const goPrev = () => setCurrentIndex((prev) => (prev - 1 + videos.length) % videos.length);

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm"
      onClick={onClose}
    >
      <div 
        className="relative w-full max-w-3xl mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button 
          onClick={onClose}
          className="absolute -top-10 right-0 text-white/70 hover:text-white transition-colors"
          data-testid="btn-close-video"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Video */}
        <div className="relative bg-black rounded-xl overflow-hidden shadow-2xl shadow-[#aa2aff]/20">
          <div className="aspect-video">
            <iframe
              key={videos[currentIndex].id}
              src={videos[currentIndex].url}
              title={videos[currentIndex].title}
              className="w-full h-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          
          {/* Navigation arrows */}
          {videos.length > 1 && (
            <>
              <button
                onClick={goPrev}
                className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center transition-colors"
                data-testid="btn-video-prev"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                onClick={goNext}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center transition-colors"
                data-testid="btn-video-next"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </>
          )}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-4">
          {videos.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrentIndex(idx)}
              className={`w-2.5 h-2.5 rounded-full transition-all ${
                idx === currentIndex
                  ? 'bg-[#aa2aff] scale-125'
                  : 'bg-white/30 hover:bg-white/50'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export function VideoCarouselButton({ onClick }) {
  return (
    <Button
      onClick={onClick}
      variant="outline"
      size="sm"
      className="border-[#aa2aff]/30 text-[#aa2aff] hover:bg-[#aa2aff]/10 hover:border-[#aa2aff] gap-2"
      data-testid="btn-open-videos"
    >
      <Play className="w-4 h-4" />
      Videos
    </Button>
  );
}

export default VideoCarouselModal;
